/* eslint-disable */
import React from 'react'
import Logo from '../../components/Logo'

export default ({children}) => (
	<header className="account-selection">
    <div className="content-wrap">
      <Logo />
    </div>
    <div className="content-wrap">
			{children}
    </div>
  </header>
)


// WEBPACK FOOTER //
// ./src/containers/AccountSelector/wrapper.js